export class SuperuserPasscode {
    constructor( 
        public SuperuserPasscode?: string,
        public UpdatedBy?: string,
        public UpdatedOn?: Date,
    ) {}
}